"use client";

import { Search } from "lucide-react";

import { Input } from "@/components/ui/input";

import { debounce } from "lodash";
import { useCallback } from "react";
import { useStoreEmailFilterActions } from "../../filter/hooks/actions";
import SelectFilters from "../select-filters";

export function DataTableToolbar() {
  const { updateFilter } = useStoreEmailFilterActions();

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    updateFilter({ key: "search", value: event.target.value });
  };

  const debouncedHandleInputChange = useCallback(
    debounce(handleInputChange, 500),
    []
  );

  const searchInput: JSX.Element = (
    <div className="relative flex-shrink-0">
      <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
      <Input
        placeholder="Nome, operador ou loja"
        onChange={debouncedHandleInputChange}
        className="h-9 w-[250px] pl-8 text-sm [border:1px_solid_rgb(209,213,219)] rounded-lg"
      />
    </div>
  );

  return (
    <SelectFilters searchInput={searchInput} />
  );
}
